module.exports = __webpack_public_path__ + "static/media/sharpko-large-dashboard.05b45ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Sharpko/sharpko-large-dashboard.jpg
// module id = 699
// module chunks = 0